import { render } from "./EmployerCoverageDrilldownModal.vue?vue&type=template&id=95973b52&scoped=true"
import script from "./EmployerCoverageDrilldownModal.vue?vue&type=script&lang=js"
export * from "./EmployerCoverageDrilldownModal.vue?vue&type=script&lang=js"

import "./EmployerCoverageDrilldownModal.vue?vue&type=style&index=0&id=95973b52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95973b52"

export default script